import { FC, ReactNode } from 'react';

import {
  Icon,
  Typography,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import classes from './BookingObjectAttribute.module.scss';

export interface BookingObjectAttributeProps {
  children?: ReactNode;
  iconName?: Icons;
  testId?: string;
}

export const BookingObjectAttribute: FC<BookingObjectAttributeProps> = ({
  children,
  iconName = Icons.Check,
  testId,
}) => {
  return (
    <div className={classes.container}>
      <Icon iconName={iconName} />
      <Typography variant='body3' data-testid={testId}>
        {children}
      </Typography>
    </div>
  );
};
